import { render, staticRenderFns } from "./bodyprint-queue-view.vue?vue&type=template&id=6d0f9f8a&"
import script from "./bodyprint-queue-view.vue?vue&type=script&lang=js&"
export * from "./bodyprint-queue-view.vue?vue&type=script&lang=js&"
import style0 from "./bodyprint-queue-view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports